const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { trustgate: trustgateApi } = require('@doctoroncallcom/api')
const {
  GET_CERTIFICATE_INFO,
} = require('./constants')

const {
  getCertificateInfoSuccess,
  getCertificateInfoError,
} = require('./actions')

const getCertificateInfo = (action$, state$, { api }) => action$.pipe(
  ofType(GET_CERTIFICATE_INFO),
  mergeMap(action => trustgateApi.getCertificateInfoApi(api, action.payload.certData)
    .then(response => getCertificateInfoSuccess(response))
    .catch(error => getCertificateInfoError(error))),
)

module.exports = {
  getCertificateInfo,
}
